var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F59B00",
    fillRule: "evenodd",
    d: "M.12 11.64c-.08.08-.12.2-.12.36 0 .16.04.32.12.48l11.4 11.4c.08.08.2.12.36.12.16 0 .3-.06.42-.18s.18-.26.18-.42c0-.16-.04-.32-.12-.48L2.04 12.6H23.4c.16 0 .3-.06.42-.18s.18-.26.18-.42c0-.16-.06-.3-.18-.42a.576.576 0 0 0-.42-.18H2.04L12.36 1.08c.16-.16.24-.32.24-.48 0-.16-.06-.3-.18-.42a.649.649 0 0 0-.48-.18c-.2 0-.34.04-.42.12L.12 11.64z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.fdc0e5eb80c52ada3429b51e4d32822d.svg";
export { ForwardRef as ReactComponent };